import { useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TimeSeriesAnalysisViewModel from '../ViewModels/TimeSeriesAnalysisViewModel';
import AnalysisFilterViewModel from '../ViewModels/AnalysisFilterViewModel';

interface IProps {
    filters: AnalysisFilterViewModel;
    data: TimeSeriesAnalysisViewModel[];
    title: string;
}

export default function TimeSeriesAnalysisChart({ filters, data, title }: IProps) {
    const rows = useMemo(() => {
        return data;
        //if (!data) {
        //    return [];
        //}
        //return [...data].sort((a, b) => {
        //    return a.mode!.localeCompare(b.mode!);
        //});
    }, [data]);

    const direction = useMemo(() => {
        switch (filters.direction) {
            case 0:
                return "Arrivals";
            case 1:
                return "Departures";
            case 2:
                return "Arrivals + Departures";
            default:
                return "";
        }
    }, [filters.direction]);

    const locationType = useMemo(() => {
        switch (filters.locationType) {
            case 0:
                return "Outer Location Types";
            case 1:
                return "Inner Location Types";
            case 2:
                return "Rural Location Types";
            case 3:
                return "All Location Types";
            default:
                return "";
        }
    }, [filters.locationType]);

    const locations = useMemo(() => {
        switch (filters.locationType) {
            case 0:
                return [
                    "Suburban Area",
                    "Edge of Town",
                    "Neighbourhood Centre (excluding Village)",
                ];
            case 1:
                return [
                    "Town Centre",
                    "Edge of Town Centre"
                ];
            case 2:
                return [
                    "Neighbourhood Centre (only Village)",
                    "Free Standing"
                ];
            default:
                return [""];
        }
    }, [filters.locationType]);

    return (
        <Grid container alignItems="start">
            <Grid container component={Paper} spacing={2} alignItems="center" size={12}>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Land Use Main Category</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{filters.landUseMain} {filters.landUseMainName}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Land Use Sub-Category</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{filters.landUseSub} {filters.landUseSubName}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Period Length</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{filters.timeSlice} Years</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Selected Start Date</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>01/01/{filters.startYear}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Selected End Date</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>31/12/{filters.endYear}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Survey Period</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{`${filters.surveyPeriodStart}:00`.padStart(5, "0")} - {`${filters.surveyPeriodEnd + 1}:00`.padStart(5, "0")}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Mode</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{filters.mode === 0 ? "Total Vehicles" : "Multi Modal"}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Direction of Flow</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{direction}</Typography>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid size="grow">
                        <Typography>Main Location Types Included</Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography>{locationType}{locations.map((loc, index) =>
                            `, ${loc}`
                        )}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} size={12}>
                <Grid size={12}>
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        Period
                                    </TableCell>
                                    <TableCell>
                                        Mode
                                    </TableCell>
                                    <TableCell>
                                        Trip Rate per {title}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, index) =>
                                    <TableRow key={"analysisRow" + index}>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.firstYear} - {row.lastYear}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.mode}</TableCell>
                                        <TableCell>{row.tripRateCount.toFixed(3)}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Grid>
    );
}
